import React, { forwardRef, KeyboardEvent } from 'react';
import { AsProp, ButtonTertiary, cssColorValue, IconMenu, semanticColors } from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

import { NavBarAvatar, NavBarAvatarProps } from 'components/Masthead/Header/Avatar';
import { useUbiMastheadHeader } from 'utils/ubi/pages/useUbiHeader';

const OpenMenuButton = styled(ButtonTertiary)`
  color: ${cssColorValue(semanticColors.textBase)};
  padding-inline-end: 0;
  &:hover {
    color: ${cssColorValue(semanticColors.textBase)};
    cursor: pointer;
  }
  &::after {
    display: none;
  }
`;
interface Props {
  onKeyDown: (e: React.KeyboardEvent<Element>) => void;
  onClick: () => void;
  label: string;
  isExpanded: boolean;
  hasProfileLinks: boolean;
  avatar: NavBarAvatarProps;
}

export const NavBarSideMenuOpenButton = forwardRef<HTMLElement, Props>(function SideMenuOpenButton(
  { onKeyDown, onClick, label, isExpanded, avatar, hasProfileLinks },
  ref,
) {
  const ubi = useUbiMastheadHeader();
  let iconProps: {
    iconOnly?: AsProp;
    iconTrailing?: AsProp;
  } = { iconOnly: IconMenu };
  if (hasProfileLinks) {
    iconProps = { iconTrailing: IconMenu };
  }

  return (
    <OpenMenuButton
      size="medium"
      data-testid="navigation-sidemenu-trigger"
      tabIndex={0}
      onKeyDown={(e: KeyboardEvent) => {
        if (hasProfileLinks && (e.key === ' ' || e.key === 'Enter')) {
          ubi.logAvatarInteraction(true);
        }
        onKeyDown(e);
      }}
      onClick={() => {
        if (hasProfileLinks) {
          ubi.logAvatarInteraction(true);
        }
        onClick();
      }}
      aria-label={label}
      aria-expanded={isExpanded}
      ref={ref}
      {...iconProps}
    >
      {hasProfileLinks ? <NavBarAvatar loading={avatar.loading} src={avatar.src} /> : null}
    </OpenMenuButton>
  );
});
